import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/Buttons/Button';
import ButtonDropdown from 'components/Buttons/ButtonDropdown';
import InputSelect from 'components/Inputs/inputSelect';
import { Tabs } from 'xland-ui';

function PanelHeader(props) {
  const {
    title, subtitle, tabs, onTab, activeTab,
    actions, actionsFirst,
  } = props;

  const handleOnTab = (tab) => {
    if (onTab) {
      onTab(tab);
    }
  };

  useEffect(() => {
    if (!activeTab && activeTab !== 0) {
      handleOnTab(tabs.find(tab => !tab.hide)?.key);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderTabs = () => (tabs && tabs.length ? (
    <>
      <div className='panel-heading-tabs'>
        <Tabs tabs={tabs} onClick={handleOnTab} activeTab={activeTab} />
      </div>
      <div className='panel-heading-tabs-selector'>
        <InputSelect
          className='w-100'
          onChange={tab => handleOnTab(tab)}
          value={tabs[activeTab] || activeTab}
          isRequired
          options={tabs.map((tab) => ({ id: tab.key, name: tab.name }))}
        />
      </div>
    </>
  ) : null);
  const haveTitle = title || subtitle;
  const formatTitle = typeof title !== 'string' ? title?.[activeTab] || '' : title;
  const formatSubtitle = typeof subtitle !== 'string' ? subtitle?.[activeTab] || '' : subtitle;
  return (
    <div className='panel-heading'>
      {
        haveTitle ? (
          <div className='panel-heading-info'>
            { title && (<h4>{formatTitle}</h4>) }
            { subtitle && (<p>{formatSubtitle}</p>) }
          </div>
        ) : null
      }
      {
        ((tabs && tabs.length) || (actions && actions.length)) ? (
          <div className='panel-heading-right'>
            {!actionsFirst && renderTabs()}
            {
              actions.length > 0 && (
                <div className='panel-heading-actions'>
                  {
                    actions.map((action, i) => {
                      if (action.buttons) {
                        return <ButtonDropdown key={i} {...action} />;
                      }
                      return <Button key={i} {...action} />;
                    })
                  }
                </div>
              )
            }
            {actionsFirst && renderTabs()}
          </div>
        ) : null
      }
    </div>
  );
}

PanelHeader.displayName = 'PanelHeader';
PanelHeader.propTypes = {
  breadcrumb: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  subtitle: PropTypes.string,
  actions: PropTypes.array,
  tabs: PropTypes.array,
  justify: PropTypes.string,
  activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onTab: PropTypes.func,
  actionsFirst: PropTypes.bool,
  hash: PropTypes.bool,
};

PanelHeader.defaultProps = {
  breadcrumb: false,
  title: '',
  subtitle: '',
  actions: [],
  tabs: [],
  activeTab: 0,
  justify: '',
  onTab: null,
  actionsFirst: false,
  hash: false,
};

export default PanelHeader;
